<template>
  <div :style="{position: 'absolute', left:getX + 'px', top:getY + 'px'}" :key="count">
    <svg xmlns="http://www.w3.org/2000/svg">
      <path
        :d="getPath(0)"
        :fill="getColorLeft"
        stroke="none"
        @mouseover="handleOver(0)"
        @mouseleave="handleLeave(0)"
      />
      <path
        :d="getPath(1)"
        :fill="getColorRight"
        stroke="none"
        @mouseover="handleOver(1)"
        @mouseleave="handleLeave(1)"
      />
    </svg>
  </div>
</template>

<script>
//import { EventBus } from "@/event-bus.js";

export default {
  props: {
    faceSize: {
      type: Number,
      return: 0,
    },
    indexX: {
      type: Number,
      default: 0,
    },
    indexY: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    clearColor: function (_index) {
      var _c = 10; //Math.floor(Math.random() * this.maxIndex);
      //console.log("clear color " + _index);
      if (_index == 0) {
        this.colorIndex0 = _c;
      } else {
        this.colorIndex1 = _c;
      }
    },
    handleLeave: function (_index) {
      //console.log(_index);
      this.isOver = false;
      this.count++;

      //var _c = Math.floor(Math.random() * this.maxIndex);

      if (_index == 0) {
        //this.colorIndex0 = _c
        setTimeout(() => {
          this.clearColor(0);
        }, 300);
      } else {
        //this.colorIndex1 = _c
        setTimeout(() => {
          this.clearColor(1);
        }, 300);
      }
    },
    handleOver: function (_index) {
      //this.colorIndex[_index] = 0; //Math.floor(Math.random() * this.maxIndex);
      //console.log(this.colorIndex[_index]);
      if (this.isOver == false) {
        var _c = _index == 0 ? this.colorIndex0 : this.colorIndex1;

        /*if (_c < 5) {
          _c = 10
        } else {
          _c = Math.floor(Math.random() * 5)
        }*/

        _c = Math.floor(Math.random() * 5); //this.maxIndex);

        if (_index == 0) {
          this.colorIndex0 = _c;
        } else {
          this.colorIndex1 = _c;
        }

        this.isOver = true;
        this.count++;
      }
    },

    getColor: function (_index) {
      var _c;
      var _colorIndex = _index == 0 ? this.colorIndex0 : this.colorIndex1;
      //console.log("set " + _index + " " + this.colorIndex[_index]);

      switch (_colorIndex) {
        case 4:
          _c = "#00bb00";
          break;
        case 5:
          _c = "none";
          break;
        case 1:
          _c = "#e3e3e3";
          break;
        case 2:
          _c = "#b9b9b9";
          break;
        case 3:
          _c = "#7b7b7b";
          break;
        case 0:
          if (Math.random() < 0.3) {
            _c = "#00bb00";
          } else {
            _c = "#dddd00";
          }
          break;
        default:
          _c = "#ffffff";
          break;
      }

      /*
      console.log("Get color");
      console.log(_index);
      console.log(this.colorIndex[_index]);
      console.log(_c);
      */

      return _c;
    },
    getPath: function (_index) {
      var _x = this.indexX;
      var _y = this.indexY;

      var _p;
      var SQUARE_SIZE = this.faceSize;

      var _offset = false;
      if ((_y + _x) % 2 == 0) {
        _offset = true;
      }
      /*
      var _offset = 0;
      var SQUARE_SIZE = this.faceSize;

      if (_y % 2) {
        _offset = 2;
      }

      var _t = (_x + _offset + 2) % 4; //+ _index;
      */

      //console.log(_x + _y);
      var _t;
      if (_index == 1) {
        _t = 0;
      } else {
        _t = 1;
      }

      if (_offset) {
        _t += 2;
      }
      switch (_t) {
        case 0:
          _p = [
            "M",
            0,
            0,
            "L",
            SQUARE_SIZE,
            SQUARE_SIZE,
            "L",
            0,
            SQUARE_SIZE,
            "L",
            0,
            0,
          ];
          break;
        case 1:
          _p = [
            "M",
            0,
            0,
            "L",
            SQUARE_SIZE,
            0,
            "L",
            SQUARE_SIZE,
            SQUARE_SIZE,
            "L",
            0,
            0,
          ];
          break;
        case 2:
          _p = ["M", 0, 0, "L", SQUARE_SIZE, 0, "L", 0, SQUARE_SIZE, "L", 0, 0];

          break;
        case 3:
          _p = [
            "M",
            SQUARE_SIZE,
            0,
            "L",
            SQUARE_SIZE,
            SQUARE_SIZE,
            "L",
            0,
            SQUARE_SIZE,
            "L",
            SQUARE_SIZE,
            0,
          ];
          break;
      }

      var _c = "";

      for (var i = 0; i < 4; i++) {
        var _r = i * 3;
        //console.log(i);
        _c += _p[_r] + _p[_r + 1] + "," + _p[_r + 2] + " ";
      }

      /*
      console.log("TRIANGLE");
      console.log(_index);
      console.log(_t);
      console.log(_c);
      */
      return _c;
    },
  },
  computed: {
    getColorLeft: function () {
      //console.log("color left");
      return this.getColor(0);
    },
    getColorRight: function () {
      //console.log("color right");
      return this.getColor(1);
    },
    getX: function () {
      return Math.floor(this.indexX) * this.faceSize;
    },
    getY: function () {
      return this.indexY * this.faceSize;
    },
  },
  created() {
    this.colorIndex0 = Math.floor(Math.random() * this.maxIndex);
    this.colorIndex1 = Math.floor(Math.random() * this.maxIndex);
  },
  data() {
    return {
      arrColor: [],
      colorIndex0: -1,
      colorIndex1: -1,
      maxIndex: 60,
      count: 0,
      isOver: false,
    };
  },
};
</script>

<style>
</style>